import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Avatar,
  FormControl,
} from "@mui/material";
import { Icon } from "@iconify/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FormAssignToField = ({
  assignees,
  assignee,
  setAssignee,
  assigneeError,
  setAssigneeError,
  noSpacing = false,
}) => {
  const uniqueAssignees = Array.from(
    new Map((assignees || []).map((item) => [item._id, item])).values(),
  );

  return (
    <Box
      sx={{
        mt: noSpacing ? 0 : 3,
        p: noSpacing ? 0 : { xs: 2, md: 4 },
        borderRadius: noSpacing ? 0 : "12px",
        backgroundColor: noSpacing ? "transparent" : "var(--app-surface)",
        width: "100%",
      }}
    >
      <Box sx={{ width: { xs: "100%", md: "50%" } }}>
        <Typography fontWeight={600} fontSize={14} mb={1}>
          Assign To <span style={{ color: "red" }}>*</span>
        </Typography>

        <FormControl fullWidth error={assigneeError}>
          <Select
            value={assignee || ""}
            displayEmpty
            onChange={(e) => {
              setAssigneeError(false);
              setAssignee(e.target.value);
            }}
            IconComponent={KeyboardArrowDownIcon}
            MenuProps={{
              anchorOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  mt: 1,
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected) return "Select Assignee";

              const selectedUser = uniqueAssignees.find(
                (item) => item._id === selected,
              );

              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar
                    src={selectedUser?.profile}
                    sx={{ width: 24, height: 24 }}
                  />
                  {selectedUser?.name}
                </Box>
              );
            }}
            sx={{
              height: "48px",
              borderRadius: "8px",
              backgroundColor: "var(--app-surface)",

              "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid var(--app-border)",
              },

              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid var(--app-border)",
              },

              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid var(--app-border)",
              },
            }}
          >
            <MenuItem disabled value="">
              Select Assignee
            </MenuItem>

            {uniqueAssignees.map((item) => (
              <MenuItem
                key={item._id}
                value={item._id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  py: 1,
                }}
              >
                <Avatar src={item.profile} sx={{ width: 28, height: 28 }} />
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {assigneeError && (
          <Typography
            sx={{
              color: "#d32f2f",
              fontSize: "13px",
              mt: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Icon icon="material-symbols:info" width="18" height="18" />
            Please select an assignee
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FormAssignToField;
